import comp from "./StudentSelection";
export default comp;
